import {Component, InputComponent} from '@wonderlandengine/api';

import {State} from './classes/gameState.js';
import {storageSpace13} from './globals.js';

export class PauseController extends Component {
    static TypeName = 'pause-controller';
    static Properties = {};

    input: InputComponent;
    canPause: boolean;
    button4Pressed: boolean;

    start() {
        this.input = this.object.getComponent(InputComponent);
        this.canPause = false;
        storageSpace13.gameState.changeOnProperty('state').add((state) => {
            this.canPause = state === State.Playing;
        });
    }

    update() {
        if (!this.canPause) {
            return;
        }
        if (this.input && this.input.xrInputSource) {
            const gamepad = this.input.xrInputSource.gamepad;
            if (gamepad && gamepad.buttons[4]?.pressed && !this.button4Pressed) {
                this.button4Pressed = true;

                storageSpace13.gameState.state = State.Pause;
            } else if (gamepad && !gamepad.buttons[4]?.pressed && this.button4Pressed) {
                this.button4Pressed = false;
            }
        }
    }
}
